export default __webpack_public_path__ + "static/media/4-privada.745bf3b7.svg";